import { apiClient } from "@/api/api-client";
import createBaseService from "@/api/base-service.ts";
import type { CaseStage } from "@/features/case-record/types/case-stage.ts";

const caseStageService = {
	...createBaseService<CaseStage>("/case-stages"),

	listRespondents: async (id: string) => {
		const response = await apiClient.get(`/backoffice/case-records/respondents/${id}`);
		return response?.data;
	},
};

export default caseStageService;
